import React from 'react';
import { Check, ChatCircleDots } from '@phosphor-icons/react';
import { fmtDateTime } from './monitoringUtils';

// Casilla de la columna «Monitorización» (a la derecha de cada pregunta).
export const MonitorCell = ({ qid, mark, canEdit, disabledReason, onToggle, busy, lang }) => {
  const title = mark
    ? `${lang === 'es' ? 'Revisado por' : 'Reviewed by'} ${mark.by_name || mark.by} · ${fmtDateTime(mark.at, lang)}`
    : (canEdit ? (lang === 'es' ? 'Marcar como revisada' : 'Mark as reviewed') : disabledReason);
  return (
    <div className="w-14 shrink-0 flex items-start justify-center pt-3" title={title}>
      <button
        type="button"
        data-testid={`monitor-check-${qid}`}
        aria-pressed={!!mark}
        disabled={!canEdit || busy}
        onClick={() => onToggle(qid, !mark)}
        className={`h-8 w-8 rounded-sm border-2 flex items-center justify-center transition-colors duration-150 ${
          mark ? 'bg-teal-600 border-teal-600 text-white' : 'bg-white border-stone-300 text-transparent'
        } ${canEdit ? 'hover:border-teal-500 cursor-pointer' : 'opacity-50 cursor-not-allowed'}`}
      >
        <Check size={16} weight="bold" />
      </button>
    </div>
  );
};

// Indicador en la pregunta cuando tiene una query abierta.
export const QuestionQueryBadge = ({ qid, count, onClick, lang }) => (
  <button
    type="button"
    data-testid={`question-query-badge-${qid}`}
    onClick={onClick}
    className="ml-2 inline-flex items-center gap-1 rounded-sm border border-amber-300 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800 hover:bg-amber-100"
    title={lang === 'es' ? 'Ver query de esta pregunta' : 'View query for this question'}
  >
    <ChatCircleDots size={11} weight="fill" />{count}
  </button>
);

// Punto de estado de la rejilla, con check si el cuestionario está monitorizado.
export const StatusDot = ({ colorClass, monitored, testId }) => (
  monitored ? (
    <span data-testid={testId} title="Monitorizado"
      className="inline-flex h-3.5 w-3.5 items-center justify-center rounded-full bg-green-500 ring-2 ring-green-200">
      <Check size={9} weight="bold" className="text-white" />
    </span>
  ) : (
    <span className={`inline-block h-2 w-2 rounded-full bg-current ${colorClass}`} />
  )
);
